import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import _ from 'lodash';

export default class Button extends Component {

	sectionClasses() {
		let classes = {
			"button": true,
		}
		if(typeof(this.props.type) === 'string') {
			classes[`-${this.props.type}`] = true;
		}else {
			_.each(this.props.type, (t) => {
				classes[`-${t}`] = true;
			});
		}
		if(this.props.disabled) classes['-disabled'] = true;
		
		return classNames(classes);
	}
	
	render() {
		if (this.props.to) {
			return (
				<Link className={`${this.sectionClasses()} ${this.props.className}`} to={this.props.to}>
				{this.props.children}
				</Link>
			);
		}
		return (
			<button
			className={`${this.sectionClasses()} ${this.props.className}`}
			onClick={this.props.onClick}
			disabled={this.props.disabled}
			target={this.props.target}
			>
			{this.props.children}
			</button>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js